import type { SocialPostSceneBlockV1, SocialPostScenePlanV1 } from "./social-post-scene.ts";

export type SceneImageFitLayout = {
  x: number;
  y: number;
  width: number;
  height: number;
  crop?: { x: number; y: number; width: number; height: number };
};

export const flattenSocialPostSceneBlocks = (
  blocks: SocialPostScenePlanV1["scene"]["blocks"],
): SocialPostSceneBlockV1[] => blocks;

export const flattenSocialPostSceneLeafBlocks = (
  blocks: SocialPostScenePlanV1["scene"]["blocks"],
): SocialPostSceneBlockV1[] => blocks;

export const getSceneImageFitLayout = (input: {
  imageWidth: number;
  imageHeight: number;
  frameX: number;
  frameY: number;
  frameWidth: number;
  frameHeight: number;
  fit: "cover" | "contain" | "fill";
}): SceneImageFitLayout => {
  const { imageWidth, imageHeight, frameX, frameY, frameWidth, frameHeight, fit } = input;

  if (fit === "fill") {
    return { x: frameX, y: frameY, width: frameWidth, height: frameHeight };
  }

  const imageAspect = imageWidth / imageHeight;
  const frameAspect = frameWidth / frameHeight;

  if (fit === "cover") {
    if (imageAspect > frameAspect) {
      const cropWidth = imageHeight * frameAspect;
      const cropX = (imageWidth - cropWidth) / 2;
      return {
        x: frameX,
        y: frameY,
        width: frameWidth,
        height: frameHeight,
        crop: { x: cropX, y: 0, width: cropWidth, height: imageHeight },
      };
    }

    const cropHeight = imageWidth / frameAspect;
    const cropY = (imageHeight - cropHeight) / 2;
    return {
      x: frameX,
      y: frameY,
      width: frameWidth,
      height: frameHeight,
      crop: { x: 0, y: cropY, width: imageWidth, height: cropHeight },
    };
  }

  const containScale = Math.min(frameWidth / imageWidth, frameHeight / imageHeight);
  const width = imageWidth * containScale;
  const height = imageHeight * containScale;
  const x = frameX + (frameWidth - width) / 2;
  const y = frameY + (frameHeight - height) / 2;

  return { x, y, width, height };
};
